/* Eliks personalized product page — keeps the "Add to Cart — price" button label (and, when the
   "PE · Price + urgency" block is shown, the hero price, compare-at price and SAVE badge) in sync
   with the bundle (Kaching) the customer selected, formatted in A$.
   It only READS the Kaching bar; it never touches cart logic. Loaded by snippets/pe-head.liquid. */
(function () {
  'use strict';
  if (window.__pePriceSync) return;
  window.__pePriceSync = true;

  var DEFAULT_CFG = { prefix: 'A$', code: 'AUD' };
  var timer = null;

  function parse(str) {
    var s = String(str || '').replace(/[^\d.,]/g, '');
    if (!s) return NaN;
    var dot = s.lastIndexOf('.'), comma = s.lastIndexOf(',');
    if (comma > dot) s = s.replace(/\./g, '').replace(',', '.');
    else s = s.replace(/,/g, '');
    return parseFloat(s);
  }

  function selectedBar() {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      var input = b.querySelector('input[type="radio"]');
      if ((input && input.checked) || b.classList.contains('kaching-bundles__bar--selected') || b.getAttribute('aria-checked') === 'true') return b;
    }
    return null;
  }

  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function setHidden(el, hidden) {
    if (el && el.hidden !== hidden) el.hidden = hidden;
  }

  function cfgOf(root) {
    if (!root) return DEFAULT_CFG;
    return { prefix: root.getAttribute('data-currency-prefix') || '', code: root.getAttribute('data-currency-code') || DEFAULT_CFG.code };
  }

  function format(n, cfg) {
    var active = window.Shopify && Shopify.currency && Shopify.currency.active;
    var useCustom = cfg.prefix && (!active || active === cfg.code);
    return (useCustom ? cfg.prefix : '$') + n.toFixed(2);
  }

  function apply() {
    var roots = document.querySelectorAll('[data-pe-pricing]');
    var bar = selectedBar();
    var barPrice = bar ? parse((bar.querySelector('.kaching-bundles__bar-price') || {}).textContent) : NaN;
    var barFull = bar ? parse((bar.querySelector('.kaching-bundles__bar-full-price') || {}).textContent) : NaN;

    var atcPrice = NaN, atcCfg = DEFAULT_CFG;
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var cfg = cfgOf(root);
      var price = !isNaN(barPrice) ? barPrice : parseFloat(root.getAttribute('data-price'));
      var compare = !isNaN(barPrice) ? barFull : parseFloat(root.getAttribute('data-compare'));
      if (isNaN(price)) continue;
      var onSale = !isNaN(compare) && compare > price;

      setText(root.querySelector('[data-pe-price]'), format(price, cfg));
      var cmpEl = root.querySelector('[data-pe-compare]');
      var saveEl = root.querySelector('[data-pe-save]');
      setHidden(cmpEl, !onSale);
      setHidden(saveEl, !onSale);
      if (onSale) {
        setText(cmpEl, format(compare, cfg));
        var pct = Math.round((compare - price) / compare * 100);
        setText(saveEl, (root.getAttribute('data-save-label') || 'SAVE [percent]%').replace('[percent]', pct));
      }
      atcPrice = price;
      atcCfg = cfg;
    }

    // The button price works even when the hero price block is hidden: it follows the selected bundle.
    if (isNaN(atcPrice) && !isNaN(barPrice)) atcPrice = barPrice;
    if (!isNaN(atcPrice)) {
      var spans = document.querySelectorAll('[class*="main-atc-price-span-"]');
      for (var j = 0; j < spans.length; j++) setText(spans[j], format(atcPrice, atcCfg));
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 40);
  }

  function boot() {
    apply();
    [300, 900, 2000, 4000].forEach(function (ms) { setTimeout(apply, ms); });
    new MutationObserver(schedule).observe(document.body, {
      childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'checked']
    });
    document.addEventListener('change', schedule, true);
    document.addEventListener('click', function () { setTimeout(apply, 120); }, true);
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
